import { ANALYTICS_EVENT_NAMES } from '../../constants';
import { init as engagementInit } from '@amplitude/engagement-browser';
import merge from 'lodash/merge';

/**
 * Initializes Amplitude's guides and surveys feature.
 *
 * @see: https://amplitude.com/docs/guides-and-surveys/sdk
 */
async function initializeGuidesAndSurveys(analytics, apiKey) {
  if (!apiKey) {
    return;
  }

  if (window.engagement) {
    // If the engagement SDK is already initialized, we don't need to do anything.
    return;
  }

  engagementInit(apiKey);

  await analytics.ready(async () => {
    const user = await analytics.user();

    await window.engagement?.boot({
      integrations: [
        {
          track: (event) => {
            // Tracks user interactions with guides and surveys through Segment.
            analytics.track(
              event.event_type,
              merge({}, event.event_properties, {
                context: {
                  // We need to preserve the event format because Amplitude's SDK adds a specific
                  // prefix to the event name that is necessary for measuring interactions with
                  // Guides and Surveys.
                  preserve_event_format: true,
                },
              })
            );
          },
        },
      ],
      user: {
        device_id: user?.anonymousId() ?? undefined,
        user_id: user?.id() ?? undefined,
        user_properties: {},
      },
    });

    analytics.track(ANALYTICS_EVENT_NAMES.initializeAmplitudeGuidesAndSurveys);

    // Forward events from segment for event-based Guide/Survey triggers
    // Note: These events aren't sent to the Amplitude server
    analytics.addSourceMiddleware(({ payload, next }) => {
      if (['page', 'track'].includes(payload.type()) && payload.obj.event) {
        window.engagement?.forwardEvent({
          event_type: payload.obj.event,
          event_properties: payload.obj.properties,
        });
      }

      next(payload);
    });
  });
}

export default initializeGuidesAndSurveys;
